// Shopify's cart SDK can render twice when a cart mutation finishes before its
// first data source exists. Coalesce that initial refresh; keep native updates.
customElements.whenDefined('shopify-accelerated-checkout-cart').then(() => {
  const prototype = customElements.get('shopify-accelerated-checkout-cart').prototype;
  const nativeUpdate = prototype.cartChangedCallback;
  if (typeof nativeUpdate !== 'function') return;
  const pending = new WeakMap();

  prototype.cartChangedCallback = function (...args) {
    // These SDK fields identify the observed initialization race. If Shopify
    // changes them, leave the SDK's own handler in charge.
    if (!('didInitiateRender' in this) || !('dataSource' in this) ||
        !this.didInitiateRender || this.dataSource || !this.childElementCount) {
      return nativeUpdate.apply(this, args);
    }
    if (pending.has(this)) return pending.get(this);

    const ready = new Promise((resolve) => {
      const observer = new MutationObserver(() => {
        if (!this.isConnected || this.dataSource || !this.childElementCount) {
          observer.disconnect();
          pending.delete(this);
          resolve();
        }
      });
      // The SDK replaces its light-DOM skeleton with the native wallet buttons
      // after creating the data source. No access to its closed shadow DOM.
      observer.observe(this, { childList: true });
    }).then(() => {
      if (this.isConnected && this.dataSource) return nativeUpdate.apply(this, args);
    });
    pending.set(this, ready);
    return ready;
  };
});
